export enum LOGIN_OTP_STATE {
  LOGIN_REGISTER = 'login',
  OTP_REQUEST = 'otp_request',
  OTP_REQUEST_NEW_EMAIL = 'otp_request_new_email',
  OTP_REQUEST_NEW_CODE = 'otp_request_new_code',
  OTP_INPUT = 'otp_input',
}
